import React from 'react';
import { useInsights } from 'contexts/insights';
import Pax from '@inter-ikea-guida/pax';
import { useEnablerExperiment } from 'optimizely/hooks';
import { useSceneHandler } from 'contexts/sceneHandler';
import { DesignSourceEnum } from '@insights/insights-data-provider';
import { useHistory } from 'react-router-dom';
import { AppRoutes } from 'routes';
import useHideLoadingScreen from 'hooks/useHideLoadingScreen';
import { doorsTypeFilter as paxDoorFilter } from 'rangeConfig/pax/filters/configFilters';
import { useSelector } from 'react-redux';
import { filterApplied, getMarketProducts } from 'ducks/products';
import { useAppDispatch } from 'ducks/hooks';
import { getCountry, getLanguage } from 'i18n/i18nUtils';
import { defaultKompisSettings } from 'contexts/serviceSettings';
import { isKiosk, isSafari } from 'utils/platform';

const Guide = () => {
  const history = useHistory();
  const insightsApi = useInsights();
  const abTest = useEnablerExperiment();
  const { loadVpcScene } = useSceneHandler();
  const products = useSelector(getMarketProducts);
  const dispatch = useAppDispatch();

  const countryCode = getCountry(defaultKompisSettings.locale);
  const languageCode = getLanguage(defaultKompisSettings.locale);

  const applyDoorsFilter = (doorType?: string) => {
    const keyMap: Record<string, string> = {
      hinged: 'hingedDoor',
      sliding: 'slidingDoor'
    };

    const key = doorType && keyMap[doorType];
    const doorOptions = paxDoorFilter.options.find(entry => entry.id === key);

    if (doorOptions) {
      const productIdList = products
        .filter(p => doorOptions.types.includes(p.type))
        .map(p => p.coreProductId);

      const filterState = { [doorOptions.id]: doorOptions.types };

      dispatch(
        filterApplied({
          id: 'type',
          productGroupId: 'doors',
          productIdList,
          filterState
        })
      );
    }
  };

  useHideLoadingScreen();

  return (
    <Pax
      planner="pax"
      insightsApi={insightsApi}
      abTest={abTest}
      plannerNavigationCallback={(vpcCode, doorType) => {
        if (isSafari()) {
          // Temporary fix with query params as loading the solution
          // programatically bugs out on safari for some reason
          history.push(
            `${AppRoutes.PLANNER}?vpc=${vpcCode}&vpcSource=${DesignSourceEnum.recommendation}`
          );
          applyDoorsFilter(doorType);
          return;
        }

        loadVpcScene(vpcCode, DesignSourceEnum.recommendation)
          .then(scene => scene?.init())
          .then(scene => {
            if (scene?.initialized) {
              applyDoorsFilter(doorType);
              history.push(AppRoutes.PLANNER);
            }
          });
      }}
      landingPageNavigationCallback={() => history.push(AppRoutes.HOME)}
      languageCode={languageCode}
      countryCode={countryCode}
      isKiosk={isKiosk()}
    />
  );
};

export default Guide;
